import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Welcome from './pages/welcome';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from 'utils/context';
import MainPage from './pages/main';
import Dashboard from './pages/Dashboard';
import AgentPage from './pages/AgentPage';
import AdminPage from './pages/AdminPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <UserProvider>
    <React.StrictMode>
      <Router>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/main" element={<MainPage />} />
          <Route path="/research/:researchId/dashboard" element={<Dashboard />} />
          <Route path="/research/:researchId/agent/:agentId" element={<AgentPage />} />
          <Route path="/admin" element={<AdminPage />} />

        </Routes>
      </Router>
    </React.StrictMode>
  </UserProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
